import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { Star, Clock, CheckCircle2, MailOpen, ShieldAlert } from "lucide-react";
import { api, fmtScore } from "@/lib/api";
import { PageHeader } from "@/components/admin/AdminLayout";

const Kpi = ({ icon: Icon, label, value, sub, to, id }) => {
  const body = (
    <div className="bg-white border border-gray-200 rounded-lg p-5 h-full hover:border-emerald-900/40 transition-colors" data-testid={`kpi-${id}`}>
      <div className="flex items-center justify-between text-gray-500"><span className="text-xs uppercase tracking-wider font-semibold">{label}</span><Icon size={16} /></div>
      <p className="mt-3 font-display text-4xl font-extrabold tracking-tight" data-testid={`kpi-${id}-value`}>{value}</p>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  );
  return to ? <Link to={to}>{body}</Link> : body;
};

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="h-64" />;
  const openClaims = s.claims.aperta + s.claims.in_gestione;
  return (
    <div className="fade-up">
      <PageHeader title="Dashboard" sub="Panoramica di recensioni, inviti e garanzia" />
      <div className="grid grid-cols-2 xl:grid-cols-5 gap-4">
        <Kpi id="average" icon={Star} label="Media negozio" value={s.shop.count ? fmtScore(s.shop.average) : "—"} sub={`${s.shop.count} recensioni pubblicate`} />
        <Kpi id="pending" icon={Clock} label="Da moderare" value={s.reviews.pending} sub="Recensioni in attesa" to="/admin/recensioni" />
        <Kpi id="approved" icon={CheckCircle2} label="Pubblicate" value={s.reviews.approved} sub={`${s.reviews.rejected} rifiutate`} />
        <Kpi id="response-rate" icon={MailOpen} label="Tasso risposta" value={`${s.response_rate}%`} sub={`${s.invitations.scheduled} inviti programmati`} to="/admin/inviti" />
        <Kpi id="claims" icon={ShieldAlert} label="Pratiche aperte" value={openClaims} sub={`${s.claims.risolta} risolte`} to="/admin/garanzia" />
      </div>
      <div className="mt-6 bg-white border border-gray-200 rounded-lg p-5">
        <p className="font-semibold">Andamento ultime 13 settimane</p>
        <p className="text-xs text-gray-500 mb-4">Barre: nuove recensioni negozio pubblicate · Linea: voto medio</p>
        <div className="h-72" data-testid="dashboard-trend-chart">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={s.trend}>
              <CartesianGrid stroke="#F3F4F6" vertical={false} />
              <XAxis dataKey="week" tick={{ fontSize: 11 }} />
              <YAxis yAxisId="c" allowDecimals={false} tick={{ fontSize: 11 }} />
              <YAxis yAxisId="a" orientation="right" domain={[0, 5]} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Bar yAxisId="c" dataKey="count" name="Recensioni" fill="#0584D5" radius={[4, 4, 0, 0]} />
              <Line yAxisId="a" dataKey="average" name="Media" stroke="#FFB700" strokeWidth={2.5} connectNulls dot={{ r: 3 }} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
